import React, { useEffect, useRef } from 'react'
import { Redirect, Route } from 'react-router-dom'
import IsLoggedIn from '../../api/login'
import PAGES_LINKS from '../../pages/constants'
import { getCookieValue } from './../../utils/utils'
import { useHistory, useLocation } from 'react-router-dom'

const PrivateLayout = ({ component: Component, isCorporate, ...rest }) => {
  const flag = IsLoggedIn(isCorporate)
  const location = useLocation()
  const history = useHistory()
  const prevLocation = useRef()

  useEffect(() => {
    prevLocation.current = location.pathname + location.search

    if (!sessionStorage.getItem('preLoginUrl')) {
      sessionStorage.setItem('preLoginUrl', prevLocation.current)
      sessionStorage.setItem('preLoginUrl_called', true)
    }
  }, [])

  useEffect(() => {
    const customerCodeToken = getCookieValue('customerCodeToken')
    const rememberCustomerCodeToken = getCookieValue(
      'rememberCustomerCodeToken'
    )

    if (customerCodeToken && rememberCustomerCodeToken) {
      let logInData = customerCodeToken.split(' ')
      if (logInData[0] === localStorage.getItem('code')) {
        history.push(
          `${PAGES_LINKS.more.root}${PAGES_LINKS.more.paltelCorporate.root}`
        )
      }
    }
  }, [])

  return (
    <Route
      {...rest}
      render={() => {
        if (flag) {
          return <Component {...rest} />
        } else
          return (
            <Redirect
              to={isCorporate ? PAGES_LINKS.home.root : PAGES_LINKS.main}
            />
          )
      }}
    />
  )
}

export default PrivateLayout
